
import { ProductList } from "@/components/professional/ProductList";
import { type Product } from "@/components/services/products/types";

interface ProductsSectionProps {
  products: Product[];
  isLoading: boolean;
}

export const ProductsSection = ({ products, isLoading }: ProductsSectionProps) => {
  return (
    <div>
      <h3 className="text-xl font-medium mb-4">Produits pharmaceutiques</h3>
      <ProductList 
        products={products}
        isLoading={isLoading}
      />
    </div>
  );
};
